import { useCallback, useEffect, useRef, useState } from "react";
import { Music, Volume2, VolumeX } from "lucide-react";

const SONG_URL = "/official-song.mp3";

export function OfficialSongPlayer() {
  const mediaRef = useRef(null);
  const timerRef = useRef(null);
  const startingRef = useRef(false);
  const stateRef = useRef("ready");
  const [state, setState] = useState("ready");
  const updateState = (next) => { stateRef.current = next; setState(next); };

  const playPreview = useCallback(async () => {
    if (startingRef.current || stateRef.current === "playing") return;
    startingRef.current = true;
    try {
      clearTimeout(timerRef.current);
      const media = mediaRef.current;
      media.pause();
      if (media.currentTime > 0) media.currentTime = 0;
      media.muted = false;
      media.volume = 0.42;
      await media.play();
      updateState("playing");
      timerRef.current = setTimeout(() => { media.muted = true; updateState("muted"); }, 15000);
    } catch { updateState("ready"); }
    finally { startingRef.current = false; }
  }, []);

  useEffect(() => {
    window.addEventListener("pointerdown", playPreview, { once: true });
    window.addEventListener("keydown", playPreview, { once: true });
    return () => { window.removeEventListener("pointerdown", playPreview); window.removeEventListener("keydown", playPreview); };
  }, [playPreview]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <div className="ns-song-player" data-testid="official-song-player">
      <audio ref={mediaRef} src={SONG_URL} preload="metadata" />
      <button data-testid="official-song-button" onClick={playPreview} aria-label="Play official song preview">
        {state === "playing" ? <Volume2 size={17} /> : state === "muted" ? <VolumeX size={17} /> : <Music size={17} />}
      </button>
      <span>{state === "playing" ? "Official song playing · mutes in 15 sec" : state === "muted" ? "Official song muted" : "Official song starts after your first tap"}</span>
    </div>
  );
}
